
import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
@Component
export default class ToggleVersionV extends Vue {
    @Prop() version: number | undefined;

    ramp3() {
        this.$emit('ramp3');
    }

    ramp4() {
        this.$emit('ramp4');
    }
}
